/**
 * Accordion Small Component
 * 小的 Accordion 组件交互逻辑
 */

(function() {
  'use strict';

  function initAccordionSmall() {
    const accordionHeaders = document.querySelectorAll('[data-accordion-small-toggle]');
    
    // 初始化：确保默认展开的项正确显示
    accordionHeaders.forEach(header => {
      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const content = header.closest('.accordion-item-small')?.querySelector('[data-accordion-small-content]');
      
      if (isExpanded && content) {
        content.classList.add('active');
      }
    });
    
    // 点击事件处理：展开/收起
    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const content = this.closest('.accordion-item-small')?.querySelector('[data-accordion-small-content]');
        
        // 切换当前面板
        if (!isExpanded) {
          // 展开
          this.setAttribute('aria-expanded', 'true');
          if (content) {
            content.classList.add('active');
          }
        } else {
          // 收起
          this.setAttribute('aria-expanded', 'false');
          if (content) {
            content.classList.remove('active');
          }
        }
      });
    });
  }

  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionSmall);
  } else {
    initAccordionSmall();
  }
})();

